import type { IconNode } from '../types';

/**
 * @name cup-saucer
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxOGE0IDQgMCAwIDAgNCA0aDEyYTQgNCAwIDAgMCA0LTRaIiAvPgogIDxwYXRoIGQ9Ik02IDhoMTJ2NmE0IDQgMCAwIDEtNCA0aC00YTQgNCAwIDAgMS00LTRaIiAvPgogIDxwYXRoIGQ9Ik0xOCA4aDFhMyAzIDAgMCAxIDMgM3YwYTMgMyAwIDAgMS0zIDNoLTEiIC8+CiAgPHBhdGggZD0iTTYgNGExIDEgMCAwIDEgMS0xIDEgMSAwIDAgMCAxLTEiIC8+CiAgPHBhdGggZD0iTTEyIDRhMSAxIDAgMCAxIDEtMSAxIDEgMCAwIDAgMS0xIiAvPgogIDxwYXRoIGQ9Ik0xOCA0YTEgMSAwIDAgMSAxLTEgMSAxIDAgMCAwIDEtMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cup-saucer
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cupSaucer: IconNode = [
  ['path', { d: 'M2 18a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z', key: '1silyx' }],
  ['path', { d: 'M6 8h12v6a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4Z', key: 'alhims' }],
  ['path', { d: 'M18 8h1a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3h-1', key: '1wo34u' }],
  ['path', { d: 'M6 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: '1lp5dp' }],
  ['path', { d: 'M12 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: '1y07zq' }],
  ['path', { d: 'M18 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: '19urv6' }],
];

export default cupSaucer;
